// Centralized application type color/letter mapping used by map pins and timelines

const PURPLE = '#7454A5'

export const APPLICATION_TYPES = {
  // Mirrors `CATEGORY_NAMES` in `src/worker/report_generation/report_generation.py`
  // `color` = map polygons/pins (high-viz neon), `labelColor` = panel text/chips (darker for readability)
  'Rezoning': { color: '#B026FF', labelColor: '#B026FF', letter: 'R', category: 'Core' },
  'CUP/SUP': { color: '#E91E63', labelColor: '#E91E63', letter: 'U', category: 'Core' },
  'Variance': { color: '#F57C00', labelColor: '#F57C00', letter: 'V', category: 'Core' },
  'Plat': { color: '#00FFD5', labelColor: '#00B89C', letter: 'P', category: 'Core' },
  'Site Plan': { color: '#D4C800', labelColor: '#B0A800', letter: 'S', category: 'Core' },
  'Annexation': { color: '#39FF14', labelColor: '#2DB812', letter: 'A', category: 'Core' },
  'CPA': { color: '#5E35B1', labelColor: '#5E35B1', letter: 'C', category: 'Core' },
}

/** Map color priority when a case has multiple types (highest first). */
export const APPLICATION_TYPE_PRIORITY = [
  'Annexation',
  'Plat',
  'Rezoning',
  'CUP/SUP',
  'Variance',
  'CPA',
  'Site Plan',
]

/** Display order for filter buttons, card chips, timeline labels, and legends. */
export const APPLICATION_TYPE_ORDER = [
  'Rezoning',
  'CUP/SUP',
  'Variance',
  'Plat',
  'Annexation',
  'Site Plan',
  'CPA',
]

export function getPrimaryApplicationType(app) {
  if (!app) return 'Case'
  // Prefer application_type — AppDashboard sets this to the filter-aware primary
  // type (e.g. Site Plan when only Site Plan is selected, even if Plat is also tagged).
  if (app.application_type) return app.application_type
  return getPriorityApplicationType(app)
}

/** Primary type from category_names priority only — ignores filter-aware application_type. */
export function getPriorityApplicationType(app) {
  if (!app) return 'Case'
  const types = Array.isArray(app.category_names) && app.category_names.length > 0
    ? [...new Set(app.category_names.filter(Boolean))]
    : []
  if (types.length > 0) {
    return APPLICATION_TYPE_PRIORITY.find((t) => types.includes(t)) || types[0]
  }
  if (app.application_type) return app.application_type
  return 'Case'
}

export function sortCategoryNamesForDisplay(categoryNames) {
  const types = [...new Set((categoryNames || []).filter(Boolean))]
  const ordered = APPLICATION_TYPE_ORDER.filter((t) => types.includes(t))
  const rest = types.filter((t) => !APPLICATION_TYPE_ORDER.includes(t))
  return [...ordered, ...rest]
}

/**
 * Tags shown on cards / timeline / detail header.
 * Show all categories (including Site Plan when it coexists with others).
 */
export function categoryTagsForDisplay(categoryNames) {
  return sortCategoryNamesForDisplay(categoryNames)
}

export const getApplicationStyle = (applicationType) => {
  const style = APPLICATION_TYPES[applicationType] || { color: PURPLE, labelColor: PURPLE, letter: '?', category: 'Other' }
  return style
}
